export const learningModes = {
  Navigational: "navigational",
  Interactive: "interactive",
  Learning: "learning",
  ExperienceLearning: "experiential",
  Wall: "wallactivity",
  Quiz: "quiz",
  Exit: "exit",
  AppBasket: "appbasket",
  UnderstandingBasket: "understandingbasket",
  FactualBasket: "factualbasket",
  AiTutor: "aitutor",
  HotBasket: "hotbasket",
  StudentJournery: "studentJourney",
  PracticeTest: "practice-test",
  Bookmarks: "bookMarks",
  Revision: "revision",
  Review: "review",
};

export const taskTypes = {
  learnSubTopic: "learnSubtopic",
  guidedPractice: "guidedPractise",
  assessment: "assessment",
  learnPrerequisite: "learnPrerequisite",
  standalone: "standalone",
  factualMode: "factualMode"
};

export const questionTypes = {
  mcq: "1",
  scq: "2",
  fib: "3",
  short_answer: "4",
  long_answer: "5",
  match: "6",
  tf: "7",
  reason_assertion: "8",
  sorting: "11",
  nav: "12",  
  yn: "13",
  drag_fib: "14",
  very_short_answer: "15"
};

export const status = {
  success: "success",
  error: "error",
  warning: "warning",
  info: "info",
};
